import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcStar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.13867 9.41992L3.24219 6.06055L0.390625 3.99023H3.90625L4.99023 0.650391L6.08398 3.99023H9.60938L6.75781 6.06055L7.85156 9.41992L4.99023 7.33984L2.13867 9.41992Z",
		fill: "currentColor"
	})
});
export default SvgIcStar;
